import SellerContainer from './SellerContainer';

export default SellerContainer;
